export default "/collab-eth.dfbdb1c1ad3cfd4ef5e6985dc048fec2.svg";